import React from 'react';
import GavelIcon from '@mui/icons-material/Gavel';
import LegalPage from '../../components/Legal/LegalPage';

const Terms = () => <LegalPage ns="terms" docKey="terms" icon={<GavelIcon />} />;

export default Terms;
